/**
 * @summary
 * <blockquote>Auto-generated static resources const for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

import { MODULE_RESOURCES } from './MODULE_RESOURCES';
import { PAGE_RESOURCES } from './PAGE_RESOURCES';
import { ACTION_RESOURCES } from './ACTION_RESOURCES';
import { ROUTE_RESOURCES } from './ROUTE_RESOURCES';
import { DATABASE_RESOURCES } from './DATABASE_RESOURCES';

/**
 * @summary
 * <blockquote>All static resources combined</blockquote>
 **/
export const STATIC_RESOURCES = {
  ...MODULE_RESOURCES,
  ...PAGE_RESOURCES,
  ...ACTION_RESOURCES,
  ...ROUTE_RESOURCES,
  ...DATABASE_RESOURCES,
} as const;
